import { config } from '../_config/config';
export const ASSETS_URL = config.ASSETS_URL;
export const DASHBOARD_URL = config.DASHBOARD_URL;